import { FaFacebookF, FaInstagram, FaXTwitter, FaYoutube, FaLinkedinIn } from "react-icons/fa6";
import { Clock } from "lucide-react";
import { useSite } from "@/context/SiteContext";

const PLATFORMS = [
  ["facebook", "Facebook", FaFacebookF],
  ["instagram", "Instagram", FaInstagram],
  ["x", "X", FaXTwitter],
  ["youtube", "YouTube", FaYoutube],
  ["linkedin", "LinkedIn", FaLinkedinIn],
];

const STYLES = {
  dark: "border-zinc-700 text-zinc-300 hover:border-[color:var(--red)] hover:bg-[color:var(--red)] hover:text-white",
  light: "border-zinc-300 bg-white text-zinc-800 hover:border-[color:var(--red)] hover:bg-[color:var(--red)] hover:text-white",
};

export function SocialLinks({ variant = "dark", testid = "social-links", labels = false }) {
  const { settings: s } = useSite();
  const items = PLATFORMS.filter(([k]) => s.socials?.[k]);
  if (!items.length) return null;
  return (
    <ul className="flex flex-wrap gap-2" data-testid={testid}>
      {items.map(([k, label, Icon]) => (
        <li key={k}>
          <a href={s.socials[k]} target="_blank" rel="noopener noreferrer" aria-label={`${label} hesabımız (yeni sekmede açılır)`}
            className={`inline-flex h-11 items-center justify-center gap-2 rounded-md border transition-colors ${labels ? "px-4" : "w-11"} ${STYLES[variant]}`}
            data-testid={`${testid}-${k}`}>
            <Icon className="h-4 w-4" />
            {labels && <span className="text-sm font-semibold">{label}</span>}
          </a>
        </li>
      ))}
    </ul>
  );
}

export function WorkingHours({ dark = false }) {
  const { settings: s } = useSite();
  const rows = s.working_hours || [];
  if (!rows.length) return null;
  return (
    <div data-testid="working-hours">
      <p className={`mb-2 flex items-center gap-2 text-xs font-bold uppercase tracking-widest ${dark ? "text-white" : "text-zinc-500"}`}>
        <Clock className="h-4 w-4 text-[color:var(--red)]" /> Çalışma saatleri
      </p>
      <dl className={`space-y-1 text-sm ${dark ? "text-zinc-400" : "text-zinc-700"}`}>
        {rows.map((r) => (
          <div key={r.day} className="flex justify-between gap-4">
            <dt>{r.day}</dt>
            <dd className="font-semibold">{r.hours}</dd>
          </div>
        ))}
      </dl>
      {s.hours_note && <p className="mt-2 text-xs text-zinc-500">{s.hours_note}</p>}
    </div>
  );
}
